import axios from 'axios';

export async function requestCancellationForService(merchantId: string, serviceId: string) {
  return axios.post(`/api/v1/user/merchants/${merchantId}/services/${serviceId}/request-cancellation`);
}
